export default function(store) {
  const checkedNodes = [];
  const traverse = function(node) {
    const childNodes = node.root ? node.root.childNodes : node.childNodes;
  
    childNodes.forEach(child => {
      if (child.checked) {
        checkedNodes.push(child.data.codeValue);
      }
      if (child.indeterminate) {
        traverse(child);
      }
    });
  };
  traverse(store)
  return checkedNodes;
}